(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-promo"] && !Shopify.designMode) return;
  try {
    
  if (!Shopify.designMode || view_settings.place_blocks) {
    // append all videos to the grid
    const productGrid = document.querySelector('[data-products-wrapper]');
    const promos = document.querySelectorAll('[data-collection-promo]');
    promos.forEach(promo => {
      productGrid.append(promo);
    });

    // run the global function to place the items on the grid
    loadPromos();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-reviews"] && !Shopify.designMode) return;
  try {
    
  // update the total review stars
  const shopReviewStar = `<span class="jdgm-star jdgm--on"></span>`;
  const shopReviewAllRatings = document.querySelector('.shop-reviews .jdgm-all-reviews-rating');
  const shopReviewScore = shopReviewAllRatings.dataset.score;
  shopReviewAllRatings.innerHTML = shopReviewStar + shopReviewScore;

  // move the product image, title and rating into a newly created div
  const shopReviewProductImages = document.querySelectorAll('.jdgm-carousel-item__product-image');
  shopReviewProductImages.forEach(product => {
    const shopReviewNewWrapper = document.createElement('div');
    const shopReviewItemParent = product.closest('.jdgm-carousel-item');
    shopReviewNewWrapper.classList.add('is-grid', 'has-col-2', 'has-no-col-gap', 'has-no-row-gap', 'jdgm-carousel-item__custom-top');
    shopReviewNewWrapper.append(shopReviewItemParent.querySelector('.jdgm-carousel-item__product-image'));
    shopReviewNewWrapper.append(shopReviewItemParent.querySelector('.jdgm-carousel-item__product'));
    shopReviewNewWrapper.append(shopReviewItemParent.querySelector('.jdgm-carousel-item__review-rating'));
    shopReviewItemParent.prepend(shopReviewNewWrapper);
    product.loading = 'lazy'
  })

  } catch(e) { console.error(e); }
})();
})();
